module.exports = __webpack_public_path__ + "static/img/feature2.4603838b.jpg";